<template>
  <div>
    <div id="mediaWrapper">
      <video v-if="mediaType === ItemType.Video" controlsList="nodownload" oncontextmenu="return false;" autoplay muted loop controls>
        <source v-bind:src="fileURL??undefined" type="video/mp4" />
      </video>

      <img v-else v-bind:src="fileURL??undefined" />
    </div>
  </div>
</template>

<script lang="ts">
import { ItemType } from '@/dto/enums/ItemType'
import { defineComponent } from 'vue'
import { randomFileServer } from '@/services/Api'

export default defineComponent({
  props: {
    itemURL: {
      type: String,
      required: true
    },
    mediaType: {
      type: Number,
      required: true
    }
  },

  setup() {
    return { ItemType }
  },

  computed: {
    fileURL() {
      const fs = randomFileServer()
      if (fs) {
        const fullPath = fs.concat(this.itemURL)
        return fullPath
      }
      return null
    }
  }
})
</script>

<style lang="sass" scoped>
#mediaWrapper
  border-radius: 25px
  overflow: hidden

img
  width: 100%

video
  width: 100%
</style>
